// extracted by mini-css-extract-plugin
export default {"badgeHeight":"_1u6y5rp","badgeBorder":"_1ric1x6","wixSaleBadge":"_y7jn3f","wixSaleBadgeText":"_fbjr08"};